import { z } from 'zod';
import { CLAVE_ORIGEN } from '../dominio/origenes';
import { normalizarTelefono } from '../telefono';
import { dia, textoRequerido } from './comunes';

/** Teléfono validado y normalizado a E.164. */
export const telefono = z
  .string()
  .trim()
  .transform((valor, ctx) => {
    const normalizado = normalizarTelefono(valor);
    if (!normalizado) {
      ctx.addIssue({ code: 'custom', message: 'Teléfono inválido (usa 10 dígitos o lada internacional)' });
      return z.NEVER;
    }
    return normalizado;
  });

export const crearClienteSchema = z.object({
  nombre: textoRequerido(120),
  telefono,
  fechaNacimiento: dia.nullable().optional(),
  origen: z.string().trim().regex(CLAVE_ORIGEN, 'Origen inválido'),
  origenDetalle: z.string().trim().max(200).nullable().optional(),
  notas: z.string().trim().max(1000).nullable().optional(),
});
export type CrearClienteInput = z.infer<typeof crearClienteSchema>;

export const actualizarClienteSchema = crearClienteSchema.partial();
export type ActualizarClienteInput = z.infer<typeof actualizarClienteSchema>;

export interface ClienteVista {
  id: string;
  nombre: string;
  telefono: string;
  fechaNacimiento: string | null;
  origen: string;
  origenDetalle: string | null;
  notas: string | null;
  citasTotal: number;
  cancelaciones: number;
  retardos: number;
  noShows: number;
  ultimaVisita: string | null;
}

export interface CompraResumen {
  id: string;
  folio: number;
  estado: string;
  total: number;
  fecha: string;
  motivoCancelacion: string | null;
  conceptos: string;
}

export interface FichaCliente extends ClienteVista {
  visitas: number;
  siguienteReserva: { id: string; inicio: string; servicio: string; barbero: string | null } | null;
  barberoFrecuente: { id: string; nombre: string } | null;
  compras: CompraResumen[];
  historialCitas: { id: string; inicio: string; estado: string; servicio: string; barbero: string | null; motivoCancelacion: string | null; llegoTarde: boolean }[];
  totalGastado?: number;
}
